var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 13.5548L11.2412 10.1292C11.9292 9.21043 12.3416 8.07344 12.3416 6.83737C12.3416 3.79752 9.87734 1.33325 6.83749 1.33325C3.79765 1.33325 1.33337 3.79752 1.33337 6.83737C1.33337 9.87722 3.79765 12.3415 6.83749 12.3415C8.07356 12.3415 9.21055 11.9291 10.1293 11.2411L13.5549 14.6666L14.6667 13.5548ZM2.90598 6.83737C2.90598 4.66953 4.66966 2.90586 6.83749 2.90586C9.00533 2.90586 10.769 4.66953 10.769 6.83737C10.769 9.00521 9.00533 10.7689 6.83749 10.7689C4.66966 10.7689 2.90598 9.00521 2.90598 6.83737Z",
    fill: "#AFAFAF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f31dea3cd7b6995bae35c150afae266a.svg";
export { ForwardRef as ReactComponent };